// extracted by mini-css-extract-plugin
module.exports = {"wrap":"warn-error_wrap_LMWdP"};